import React, { type JSX } from 'react';
import { Query } from '@apollo/client/react/components';
import { ApolloError } from '@apollo/client';

import {
  EkonomiskAnalysBudgetQuery as IEkonomiskAnalysBudgetQueryData,
  EkonomiskAnalysBudgetQueryVariables as IEkonomiskAnalysBudgetQueryVariables,
  EkonomiskAnalysBudgetQuery_db_EKBudget_All,
} from './_QueryTypes/EkonomiskAnalysBudgetQuery';
import query from './EkonomiskAnalysBudgetQuery.gql';
import { ActiveDatabaseConsumer } from '../../../../../../../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

interface IBudgetQueryResult {
  budgetList?: EkonomiskAnalysBudgetQuery_db_EKBudget_All[];
  loading: boolean;
  error?: ApolloError;
}

interface IProps {
  children: (budgetQueryResult: IBudgetQueryResult) => JSX.Element;
}

const EkonomiskAnalysBudgetQuery: React.FunctionComponent<IProps> = props => (
  <ActiveDatabaseConsumer>
    {({ activeDatabase }) => (
      <Query<
        IEkonomiskAnalysBudgetQueryData,
        IEkonomiskAnalysBudgetQueryVariables
      >
        query={query}
        variables={{ dbName: activeDatabase || '' }}
        skip={!activeDatabase}
      >
        {({ data, error, loading }) => {
          const budgetList =
            data && data.db && data.db.EKBudget_All
              ? data.db.EKBudget_All
              : undefined;
          return props.children({ budgetList, loading, error });
        }}
      </Query>
    )}
  </ActiveDatabaseConsumer>
);

export default EkonomiskAnalysBudgetQuery;
